import React from 'react'
import { APIEntity } from 'services/api/entities'
import { Experience } from 'services/api/entities/catalog/experience/types/internal/experience-models'
import { OptionedProductSelection } from 'services/api/entities/events/types/internal/selections'
import EventUpsellingSelectionInput from 'ui-shared/FormComponents/EventUpsellingSelectionInput'
import { SelectionDetailsProps } from 'ui-shared/FormComponents/MainProductSelectionInputContent'
import OptionSelectionInput from '../../EventsComponents/OptionSelectionInput'

type Props = SelectionDetailsProps<Experience, OptionedProductSelection> & {
  experience: Extract<APIEntity, 'virtuals' | 'physicals'>
}

const ExperienceSelectionDetailsForm: React.FC<Props> = ({
  scopedFormData,
  selectedProduct,
  isObsolete,
  getSource,
  experience,
}) => {
  if (!scopedFormData || !getSource) return null

  const { upsellingSelection } = scopedFormData

  return (
    <>
      <EventUpsellingSelectionInput
        source={getSource('upsellingSelection')}
        hideQuantity={experience === 'virtuals'}
        disableInputs={isObsolete}
        selectedProduct={selectedProduct}
        upsellingSelection={upsellingSelection}
      />

      <OptionSelectionInput
        selectedProduct={selectedProduct}
        source={getSource('optionSelections')}
        eventOptioned={scopedFormData}
        isObsolete={isObsolete}
      />
    </>
  )
}

export default ExperienceSelectionDetailsForm
